export default "__VITE_ASSET__2b71bb02__"